function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, active, enabled, inputValue, saveConfirmOpen) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'report-title-input': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((enabled) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'input-focused': active,
            }, {
              'title-input-enabled': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-autoresizing-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                placeholder: active ? `` : `Untitled report`,
                'initial-width': 140,
                'max-length': 50,
                'theme': `report-title`,
              }),
              "hook": {
                insert: $helpers.onInputInsert,
              },
              "on": {
                blur: $helpers.blur,
                focus: $helpers.focus,
                input: $helpers.inputChange,
                keydown: $helpers.keydownHandler,
              },
              "props": {
                value: inputValue,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'title-save-buttons': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `primary`,
                disabled: $helpers.isSaveDisabled(),
                icon: `save`,
              }),
              "on": {
                click: $helpers.clickSave,
                mousedown: $helpers.buttonMousedown,
              },
              "class": {
                'title-save': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Save");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($attr(`show-save-new`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  disabled: $helpers.isSaveNewDisabled(),
                }),
                "on": {
                  click: $helpers.clickSaveNew,
                  mousedown: $helpers.buttonMousedown,
                },
                "class": {
                  'title-save-new': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Save new");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-confirm", {
            "attrs": __vjadeStringifyAttrsIfObj({
              theme: `confirm`,
              'confirm-button-label': 'Update',
              open: saveConfirmOpen,
            }),
            "on": {
              submit: ev => ev.detail.action === `confirm` ? $helpers.confirmSaveReport() : $helpers.cancelSaveReport()
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-confirm-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Update report");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-confirm-description': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("You're about to save new changes to this report.  Please note:");
                __jade_nodes = __jade_nodes.concat(($attr(`has-dashboards`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("p", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("- updates will also affect dashboards");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(($attr(`has-custom-alerts`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("p", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("- custom alert thresholds may be out of date");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'title-input-disabled': true
            },
          }, [__vjadeSafeCode(inputValue)]));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "active" in locals ? locals.active : typeof active !== "undefined" ? active : undefined, "enabled" in locals ? locals.enabled : typeof enabled !== "undefined" ? enabled : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined, "saveConfirmOpen" in locals ? locals.saveConfirmOpen : typeof saveConfirmOpen !== "undefined" ? saveConfirmOpen : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;